export default "__VITE_ASSET__48743779__"